// Fichier : pages/Admin/ArticlesPage.js

import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminPage.css';

const ArticlesPage = () => {
  const navigate = useNavigate();

  return (
    <div className="admin-page">
      <h2>Gestion des articles</h2>
      <div className="admin-buttons">
        <button onClick={() => navigate('/admin/articles/ajouter')}>Ajouter un article</button>
        <button onClick={() => navigate('/admin/articles/modifier')}>Modifier un article</button>
        <button onClick={() => navigate('/admin/articles/supprimer')}>Supprimer un article</button>
      </div>
    </div>
  );
};

export default ArticlesPage;